import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
//
import global from 'common'
import { Formik } from 'formik'
import * as Yup from 'yup'

import DefaultInput from 'common/components/dataEntry/formik/FormikDefaultInputField'
import Button from 'common/components/general/Button'

export const billingInformationValidator = (translate: any) => {
  return Yup.object({
    billingEmail: Yup.string()
      .email(translate('admin-login.errors.valid-email'))
      .required(translate('admin-login.errors.required-email')),
  })
}

interface BillingInformationProps {
  onSave: (values: BillingInformationValues) => void
  onCancel: () => void
}

export interface BillingInformationValues {
  billingEmail: string
}

const BillingInformationForm: React.FC<BillingInformationProps> = ({ onSave, onCancel }) => {
  const { t: translate } = useTranslation()
  const { isXs } = global.hooks.useBreakPoints()

  return (
    <Formik validationSchema={billingInformationValidator(translate)} onSubmit={() => {}} initialValues={{}}>
      {(formik) => (
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <Row gutter={24} className="mb-8">
            <Col xs={24} sm={16}>
              <DefaultInput
                label={translate('admin-dashboard.company-settings.subscription.billing-email')}
                name="billingEmail"
              />
            </Col>

            <Col xs={24} sm={8} className={`flex ${isXs ? 'mb-8' : 'justify-end align-end mb-8'}`}>
              <Button type="default" onClick={() => onCancel()} className="color-gray-8 mr-8">
                {translate('general.cancel')}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  onSave(formik.values as BillingInformationValues)
                }}
              >
                {translate('general.save')}
              </Button>
            </Col>
          </Row>
        </form>
      )}
    </Formik>
  )
}

export default BillingInformationForm
